module.exports = __webpack_public_path__ + "static/media/comment2.5227de89.svg";